var soundManager = require('SoundManager2').soundManager;
const sm = soundManager.setup({
	preferFlash: false
})

export default sm;


// WEBPACK FOOTER //
// ./src/audio/sound-manager.js